<mat-form-field class="w-100 h-100" appearance="outline">
  @if (label) {
    <mat-label>{{ label | translate }}</mat-label>
  }

  <textarea
    matInput
    class="w-100 h-100 crm-scroll custom-textarea"
    [readonly]="readonly"
    [placeholder]="placeholder"
    [maxlength]="maxLength"
    [formControl]="formControl"
    [disabled]="disabled"
    (input)="onChange($event)"
  ></textarea>

  @if (formControl?.touched && formControl?.invalid) {
    <mat-error>
      @if (formControl.errors?.['required']) {
        {{ 'input_errors.required' | translate }}
      }
      @if (formControl.errors?.['maxlength']) {
        {{
          'input_errors.maxlength'
            | translate: { value: $safeNavigationMigration(formControl.errors?.['maxlength']?.requiredLength) }
        }}
      }
      @if (formControl.errors?.['minlength']) {
        {{
          'input_errors.minlength'
            | translate: { value: $safeNavigationMigration(formControl.errors?.['minlength']?.requiredLength) }
        }}
      }
    </mat-error>
  }

  @if (maxLength) {
    <mat-hint align="end"> {{ formControl.value?.length || 0 }}/{{ maxLength }} </mat-hint>
  }
</mat-form-field>
